import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../il8n/lang';
import { connect } from 'react-redux';
import './WhereToBuy.css';
import { toggleInterstitial } from '../../Actions/Index';
import { mapATGLoc } from '../../utils';
import { cdnBase } from '../../const';


/**
 * Where to Buy
 * @constructor
 */

class WhereToBuy extends Component {
  render() {
    // if(mapATGLoc() === 'fr'){
    //   return (
    //     <div className="wrapper">
    //       <div className="wtb_header">
    //         <h2 className="h2">{lang.home.sections.retailers.header} </h2>
    //       </div>
    //       <div className='retailer-fr-container'>
    //         <div className='column'>
    //         {lang.home.sections.retailers.retailers1.map((retailer, index) => {
    //           return (
    //             <div className='retailer-fr' key={`retailers___${index}`}>
    //               <a target='_blank' rel='noopener noreferrer' onClick={() => {
    //                     if (retailer.href !== '') {
    //                       this.props.dispatch(toggleInterstitial(true, retailer.href))
    //                     }
    //                   }}>
    //                 <img className="retailer-img-fr" src={retailer.img} />
    //               </a>
    //             </div>
    //           )
    //         })}
    //         </div>
    //         <div className='column'>
    //         {lang.home.sections.retailers.retailers2.map((retailer, index) => {
    //           return (
    //             <div className='retailer-fr' key={`retailers___${index}`}>
    //               <a target='_blank' rel='noopener noreferrer' onClick={() => {
    //                     if (retailer.href !== '') {
    //                       this.props.dispatch(toggleInterstitial(true, retailer.href))
    //                     }
    //                   }}>
    //                 <img className="retailer-img-fr" src={retailer.img} />
    //               </a>
    //             </div>
    //           )
    //         })}
    //         </div>
    //         <div className='column'>
    //         {lang.home.sections.retailers.retailers3.map((retailer, index) => {
    //           return (
    //             <div className='retailer-fr'>
    //               <a target='_blank' rel='noopener noreferrer' onClick={() => {
    //                     if (retailer.href !== '') {
    //                       this.props.dispatch(toggleInterstitial(true, retailer.href))
    //                     }
    //                   }}>
    //                 <img className="retailer-img-fr" src={retailer.img} />
    //               </a>
    //             </div>
    //           )
    //         })}
    //         </div>
    //     </div>
    //     </div>
    //   )
    // }
    return (
      <div className="section" id="wheretobuy">
        <div className="section__bg section--bg" style={{ backgroundImage: `url("${cdnBase}Where-to-Buy-Background.jpg")` }}>
          <div className="section__topborder" style={{ backgroundImage: `url("${cdnBase}Tile_Black_Divider.png")` }}>
          </div>
        </div>
        <div className="section__fg section__wtb">
          <div className="wtb_section">
            <div className='wtb__wrap'>
              <div className='retailers'>
                <div className="wtb_header">
                  <h2 className="h2">{lang.home.sections.retailers.header} </h2>
                </div>
                <div className='retailers-list'>
                  {lang.home.sections.retailers.retailers.map((retailer, index) => (
                    <div className='retailer' key={`retailers___${index}`}>
                      <a target='_blank' rel='noopener noreferrer' onClick={() => {
                        if (retailer.href !== '') {
                          this.props.dispatch(toggleInterstitial(true, retailer.href))
                        }
                      }}>
                        <img className="retailer-img" id={`${retailer.id}`} src={retailer.img} alt={retailer.name} />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return { lang: state.lang };
}

export default connect(mapStateToProps)(WhereToBuy);
